const initialState = {
	isLoading: false,
	metaData: siteData.meta ? JSON.parse( siteData.meta ) : false,
	post: {
		byId: {
			'1': {
				id: '1',
				title: 'value',
				meta: ['_intro', '_notes'],
				sections: ['1', '2'],
			}
		},
		allIds: ['1', '2']
	},
	meta: {
		byId: {
			_intro: {
				id: '_intro',
				value: 'meta value intro'
			},
			_notes: {
				id: '_intro',
				value: 'meta value notes'
			}
		},
		allIds: ['_intro', '_notes'],
	},
	section: {
		byId: {
			'1': {
				id: '1',
				content: 'Section 1 Content'
			},
			'2': {
				id: '2',
				content: 'Section 2 Content'
			}
		},
		allIds: ['1', '2']
	}
}

// const post = state.posts.byId[postId]

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'UPDATE':
			return {
				...state,
				[ payload.id ]: payload.value
			}

		case 'SAVE':
			return {
				...state,
				[ payload.id ]: payload.value
			}

		// case 'ADD_SECTION':
		// 	const { sectionId, sectionValue } = payload
		// 	const section = {
		// 		id : sectionId,
		// 		value : sectionValue
		// 	}

		// 	return {
		// 		...state,
		// 		[ sectionId ]: section
		// 	}

		// case 'ADD_SECTION_TO_PAGE':
		// 	const { sectionId, sectionValue } = payload
		// 	const post = state.post[ postId ]

		// 	return {
		// 		...state,
		// 		[ postId ]: {
		// 			...post,
		// 			sections : post.sections.concat( sectionId )
		// 		}
		// 	}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/content.jsx